
























import { defineComponent, onMounted, reactive, toRefs } from '@vue/composition-api';
import Form from '@/components/Form/index.vue';
import Pagination from '@/components/Pagination';
import request from '@/utils/request';
import addComma from '@/utils/addComma';
import { userInfor as userInfoRef } from '@/useable/login';
const userInfor = userInfoRef.value;

export default defineComponent({
  name: 'financingSearch',
  components: {
    Form,
    Pagination,
  },
  setup(props, { root }) {
    const state: any = reactive({
      form: {
        supplierId: '',
        bankCode: '',
        orderType: '',
        applyStatus: '',
        applyNo: '',
        orderNo: ''
      },
      downloadUrl: 'financing-financingExport',  // 文件-下载地址
      total: 15,
      pageSize: 10,
      page: 1,
      showPagination: true,
      tableConfig: {
        column: [
          {key: 'createTime', label: '月份', width: 150 },
          {key: 'applyNo', label: '融资申请单号', width: 150 },
          {key: 'orderTypeName', label: '付款单类型', width: 100},
          {key: 'orderNo', label: '付款单号', width: 210},
          {key: 'payCorpName', label: '付款企业', width: 120},
          {key: 'supplierName', label: '融资企业名称', width: 120},
          {key: 'totalAmount', label: '可融资金额', custom: true, width: 130, align: 'right', headerAlign: 'right'},
          {key: 'applyAmount', label: '申请融资金额', custom: true, width: 130, align: 'right', headerAlign: 'right'},
          {key: 'currency', label: '币种', width: 70},
          {key: 'bankName', label: '融资银行名称', width: 110},
          {key: 'applyPersonName', label: '申请人姓名', width: 100},
          {key: 'applyStatusName', label: '融资申请状态', width: 120},
          {key: 'applyDate', label: '融资申请日期', width: 120},
          {key: 'planPayTime', label: '融资到期日', width: 120},
          {key: 'operate', label: '操作', operate: true, width: 90}
        ],
        data: []
      },
      formColumn: [
        {
          name: 'supplierId',
          type: 'AsyncSelect',
          asyncName: 'name',
          label: '融资企业名称：',
          disabled: false,
          placeholder: '输入融资企业名称',
          options: [],
          url: 'financing-supplierInfoSelect',
        },
        {
          name: 'bankCode',
          type: 'select',
          label: '融资银行：',
          placeholder: '请选择',
          options: [],
        },
        {
          name: 'orderType',
          type: 'select',
          label: '付款单类型：',
          placeholder: '请选择',
          options: [],
        },
        {
          name: 'applyStatus',
          type: 'select',
          label: '融资申请单状态：',
          placeholder: '请选择',
          options: [],
        },
        {
          name: 'applyNo',
          type: 'input',
          label: '融资申请单号：',
          placeholder: '输入融资申请单号',
          options: [],
        },
        {
          name: 'orderNo',
          type: 'input',
          label: '付款单号：',
          placeholder: '输入付款单号',
          options: [],
        }
      ],
      selectArray: [],
      isCore: userInfor.isCore
    });
    const getData = () => {
      state.formColumn.map((item) => {
        if ( item.name === 'supplierId') {
          item.disabled = !state.isCore;
          state.form[item.name] = state.isCore ? '' : userInfor.supplierId;
          return item;
        }
        return item ;
      });
      Promise.all([
        request('financing', 'getDict', {}),
        request('financing', 'bankList', {supplierId: userInfor.supplierId}),
        request('financing', 'supplierInfoSelect', {supplierName: userInfor.supplierName, size: 30, current: 1}),
      ]).then((result)=>{
        if (result[0].code === 2000) {
          const { orderType, applyStatus } = result[0].data;
          filterSelect('orderType', orderType);
          filterSelect('applyStatus', applyStatus);
        }
        if (result[1].code === 2000) filterSelect('bankCode', result[1].data.filter((item)=>{
          if (userInfor.isCore) {
            return true;
          }
          return item.isSigned === 'Y';
        }).map( (item) => {
          return { name: item.bankName, value: item.bankCode };
        }));
        if (result[2].code === 2000) filterSelect('supplierId', result[2].data);
      });

      submit();
    };

    const filterSelect = (name, options) => {
      state.formColumn.map(( item: { name: any; options: any; }) => {
        if ( item.name === name ) item.options = options;
        return;
      });
    };

    const submit = async () => {
      const parms = {
        ...state.form,
        current: state.page,
        size: state.pageSize,
      };
      const result = await request('financing', 'financingList', parms);
      const { records, size, total, current } = result.data;
      state.showPagination = records.length > 0;
      state.tableConfig.data = records;
      state.total = total;
      state.pageSize = size;
      state.page = current;
    };

    const pageChange = (newPage, newSize) => {
      state.page = newPage;
      state.pageSize = newSize;
      submit();
    };

    const onSearch = (val) => {
      state.form = val;
      state.page = 1;
      submit();
    };

    const toDetail = async (row) => {
      if ( row.applyStatus === 0 && !state.isCore) {
        const { code } = await request('financing', 'checkSupplierRegisterStatus');
        if (code === 2000) {
          const routeUrl1 = root.$router.resolve({
            path: 'edit/editTwo',
            query: {
              financeOrderApplyId: row.financeOrderApplyId
            }
          });
          window.open(routeUrl1.href, '_blank');
        }
      } else if ( row.applyStatus === 1 && !state.isCore ) {
        const { code } = await request('financing', 'checkSupplierRegisterStatus');
        if (code === 2000) {
          const routeUrl2 = root.$router.resolve(`edit/editThree/${row.financeOrderApplyId}`);
          window.open(routeUrl2.href, '_blank');
        }
      } else {
        const routeUrl3 = root.$router.resolve(`detail/${row.financeOrderApplyId}`);
        window.open(routeUrl3.href, '_blank');
      }
    };
    onMounted(getData);
    return {
      ...toRefs(state),
      pageChange,
      onSearch,
      toDetail,
      addComma
    };
  },
});
